import React, {useEffect, useState, useContext} from 'react';
import Cookies from 'js-cookie';
import './Modal.less';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {createCookie, cookieExists, APP_BANNER_COOKIE_NAME} from '../utils/cookies';
import * as BannerDefaults from '../banner-defaults';
import * as BannerHelpers from '../utils/bannerHelpers';
import {triggerEdapEvent} from '../utils/triggerEdapEvent';

export const BannerModal = ({buttonLabel,
    ctaLink,
    title,
    description,
    closeButtonText,
    travelerApp,
    useCanonicalPath}) => {
    buttonLabel = BannerHelpers.getButtonLabel(buttonLabel);
    const context = useContext(TrackingContext);
    const brandName = BannerHelpers.getBrandName(travelerApp);
    const site = BannerHelpers.getSite(brandName);
    const imgUrl = BannerHelpers.getImgUrl(site);
    title = title || BannerDefaults.TITLE.replace('brand', brandName);
    description = description || BannerDefaults.DESCRIPTION;
    closeButtonText = closeButtonText || BannerDefaults.MODAL_CLOSE_BUTTON_TEXT;

    function createLink() {
        return BannerHelpers.getDownloadLink(ctaLink, brandName, Cookies.get('hav'), Cookies.get('xdid'));
    }

    const [path, setPath] = typeof window !== 'undefined' ? useState(window.location) : '';

    const [showModalState, setShowModalState] = useState(false);
    const [modalSelected, setModalSelected] = useState(null);
    const [modalPresented, setModalPresented] = useState(null);
    const [modalDismissed, setModalDismissed] = useState(null);
    const [link, setLink] = useState(createLink());

    useEffect(() => {
        if (cookieExists(APP_BANNER_COOKIE_NAME) || modalSelected || modalDismissed) {
            setShowModalState(false);
        } else {
            setShowModalState(true);
        }
    });

    useEffect(() => {
        if (useCanonicalPath && typeof window !== 'undefined') {
            setPath(window.location);
        }
    }, [path]);

    useEffect(() => {
        if (!modalPresented && !cookieExists(APP_BANNER_COOKIE_NAME) && showModalState) {
            triggerEdapEvent(context, 'presented', 'modal');
            setModalPresented(true);
        }
    });

    function handleDownloadButtonClick() {
        setModalSelected(true);
        triggerEdapEvent(context, 'selected', 'modal');
        if (useCanonicalPath) {
            setLink(`${link}&$canonical_url=${path}`);
        }
        createCookie();
    }

    function handleCloseButtonClick() {
        setModalDismissed(true);
        triggerEdapEvent(context, 'dismissed', 'modal');
        createCookie();
    }

    return (
        <div className="popup">
            {showModalState &&
                <div className="banner-modal">
                    <div className="banner-modal__container">
                        <div className="banner-modal__app-icon">
                            <img src={imgUrl} alt={`${brandName} Logo`}/>
                        </div>
                        <div className="banner-modal__heading-text">
                            {title}
                        </div>
                        <div className="banner-modal__sub-heading-text">
                            {description}
                        </div>
                        <div className="banner-modal__download-button-div">
                            <ButtonPrimary onClick={handleDownloadButtonClick} href={link} data-testid="download-button-modal" className="banner-modal__get-app-icon" key={2} label={buttonLabel} />
                        </div>
                        <ButtonLink
                            size="xs"
                            className="banner-modal__close-button-text"
                            label={closeButtonText}
                            data-testid="modal-close-button"
                            onClick={handleCloseButtonClick}
                        />
                    </div>
                </div>
            }
        </div>
    );
};
